import type { FieldMergeFunction } from '@apollo/client'

const merge: FieldMergeFunction<NewFee[]> = (existing, incoming) => {
  return incoming
}

export default {
  merge,
}
